import { toSectionEditorContext } from '@/components/tiptap/markdown-native/editor-type';
import { type SectionEditorContext } from '@/models/analytics/features/notes';
import { type Editor } from '@tiptap/react';
import { type MarkdownSectionNodeStorage } from './section-node';

/**
 * Reads the host editor type stamped onto `MarkdownSectionNode` storage by
 * `useMarkdownNativeEditor` and maps it to the section analytics
 * `editor_context` via the shared `toSectionEditorContext`. Used by the
 * editor-driven creation paths (slash command, convert-to-section) that run
 * outside React and so can't consume the `EditorTypeProvider` context. Falls
 * back to `note` when storage is absent.
 */
// The storage-only view keeps both editor generations assignable: the moved
// kernel's `onSectionCreated` hands over a core `Editor` (which app code
// cannot name — `@tiptap/core` is not an app dependency), while the react
// `Editor` callers remain structurally compatible.
export function getSectionEditorContext(
  editor: Pick<Editor, 'storage'> | undefined
): SectionEditorContext {
  const storage = (
    editor?.storage as unknown as
      | Record<string, MarkdownSectionNodeStorage | undefined>
      | undefined
  )?.sectionNode;
  return toSectionEditorContext(storage?.editorType);
}
